import Select from "immigram-ui-cmon/src/components/Select/Select";
import { useTranslation } from "next-i18next";
import React, { useCallback } from "react";
import { Control } from "react-hook-form";
import { Controller } from "react-hook-form";

import { ValidationError } from "@/lib/hook/useValidation";

import {
  ConfigParamValueWithModifiers,
  getModifiedConfigParamValue,
  ImmigramFormElementConfigBase,
  ImmigramFormElementOnChange,
  ImmigramFormElementType,
  useModifiedConfigParamValue,
} from "./common";

export interface ImmigramFormElementConfigSelect
  extends ImmigramFormElementConfigBase {
  type: ImmigramFormElementType.Select;
  name: string;
  title: ConfigParamValueWithModifiers;
  options: {
    value: string;
    title: ConfigParamValueWithModifiers;
  }[];
}

interface ImmigramFormSelectProps {
  elementConfig: ImmigramFormElementConfigSelect;
  control: Control;
  onChange: ImmigramFormElementOnChange;
  disabled: boolean;
  validationErrors?: ValidationError | null;
}

function ImmigramFormSelect({
  elementConfig,
  control,
  onChange,
  disabled,
  validationErrors,
}: ImmigramFormSelectProps) {
  const { t } = useTranslation();
  const title = useModifiedConfigParamValue(elementConfig.title);

  const handleOnChange = useCallback(
    (value: string | string[]) => {
      onChange(elementConfig.name, value as string);
    },
    [onChange, elementConfig]
  );

  return (
    <Controller
      name={elementConfig.name}
      control={control}
      render={(renderProps) => {
        return (
          <Select
            label={title}
            name={elementConfig.name}
            options={elementConfig.options.map(({ value, title }) => ({
              title: getModifiedConfigParamValue(t, title),
              value,
            }))}
            value={renderProps.field.value}
            onChange={(value) => {
              renderProps.field.onChange(value);
              handleOnChange(value);
            }}
            disabled={disabled}
            error={validationErrors?.message}
          />
        );
      }}
    />
  );
}

export { ImmigramFormSelect };
